import React, { ComponentProps, FC, useState } from 'react'
import styled from 'styled-components'
import cx from 'classnames'

import Dropdown from '../Dropdown'
import DropdownMenuList from './DropdownMenuList'

export type Props = ComponentProps<typeof DropdownMenuList> &
  Omit<ComponentProps<typeof Dropdown>, 'overlay' | 'visible' | 'onVisibleChange'> & {
    stopClickPropagation?: boolean
    triggerWrapperCss?: any
    disabled?: boolean
    onMenuClick?: () => void
  }

export const DropdownMenu: FC<Props> = ({
  items,
  trigger,
  children,
  className,
  stopClickPropagation = false,
  triggerWrapperCss,
  'data-test': dataTest,
  disabled,
  ...restProps
}) => {
  const [isMenuVisible, setIsMenuVisible] = useState(false)

  if (disabled) {
    return <>{children}</>
  }

  return (
    <Dropdown
      {...restProps}
      visible={isMenuVisible}
      onVisibleChange={setIsMenuVisible}
      trigger={trigger ?? ['click', 'hover']}
      overlay={
        <DropdownMenuList
          data-test={dataTest}
          stopClickPropagation={stopClickPropagation}
          className={className}
          items={items}
          onClick={() => {
            setIsMenuVisible(false)
            restProps?.onMenuClick?.()
          }}
        />
      }
    >
      <TriggerWrapper
        data-test={cx('dropdown-menu-trigger', dataTest && `${dataTest}-trigger`)}
        css={triggerWrapperCss}
      >
        {children}
      </TriggerWrapper>
    </Dropdown>
  )
}

export default DropdownMenu
export type DropdownMenuProps = Props

export const TriggerWrapper = styled.div`
  // This is useful (and used) for targeting in a styled-components block
`
